import * as z from "zod";
import ContractEndTypeEnum from "@/constants/enums/ContractEndTypeEnum";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";

const contractTypeValues = Object.values(ContractTradeTypeEnum) as [string, ...string[]];
const contractEndTypeValues = Object.values(ContractEndTypeEnum) as [string, ...string[]];

export const ContractDetailsSchema = z
  .object({
    name: z
      .string({
        required_error: "validation:contractNameRequired",
        invalid_type_error: "validation:contractNameRequired",
      })
      .min(1, "validation:contractNameRequired")
      .max(100, "validation:contractNameMaxLength"),
    contractStartDate: z.coerce.date({
      required_error: "validation:startDateRequired",
      invalid_type_error: "validation:startDateRequired",
    }),
    contractType: z.enum(contractTypeValues),
    automaticSalesApproval: z.string(),
    contractManagerId: z
      .number({
        required_error: "validation:contractManagerRequired",
        invalid_type_error: "validation:contractManagerRequired",
      })
      .min(1, "validation:contractManagerRequired"),
    contactEmail: z.string().optional(),
    contactPhone: z.string().optional(),
    counterpartyContactEmail: z.string().optional(),
    counterpartyContactPhone: z.string().optional(),
    tradeAtOwnRisk: z.boolean({
      required_error: "validation:creditWarningError",
    }),
    contractEndType: z.enum(contractEndTypeValues),
    template: z.string().nullable(),
    templateName: z.string().optional().nullable(),
    poNumber: z.string().nullable().optional(),
    contractEndDate: z.coerce
      .date({
        required_error: "validation:endDateRequired",
        invalid_type_error: "validation:endDateRequired",
      })
      .nullable()
      .optional(),
    amount: z.string({
      required_error: "validation:amountRequired",
      invalid_type_error: "validation:amountRequired",
    }),
    amountUnitId: z
      .number({
        required_error: "validation:unitRequired",
        invalid_type_error: "validation:unitRequired",
      })
      .min(1, "validation:unitRequired"),
  })
  .superRefine((data, ctx) => {
    if (data.contractEndType === ContractEndTypeEnum.DATEPERIOD) {
      if (data.contractEndDate == null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation:endDateRequired",
          path: ["contractEndDate"],
        });
      }
    } else if (data.contractEndType === ContractEndTypeEnum.AMOUNT) {
      if (data.amount.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation:amountRequired",
          path: ["amount"],
        });
      }
      if (data.amountUnitId == null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation:unitRequired",
          path: ["amountUnitId"],
        });
      }
    } else {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Invalid contractEndType",
        path: ["contractEndType"],
      });
    }
  });

export type ContractDetailsInput = z.infer<typeof ContractDetailsSchema>;
